import { JSXMapSerializer } from '@prismicio/react'
import { Typography } from '@dtx-company/design-system/src'
import { UpsellModalLinkSerializer } from '@app/upsell-modals/src/PrismicUpsellModalContent/UpsellModalLinkSerializer'

export const serializer: JSXMapSerializer = {
  hyperlink: UpsellModalLinkSerializer,
  paragraph: ({ children }) => <>{children}</>,
  heading1: ({ children }) => (
    <Typography variant={'headlineLarge'} component={'h3'}>
      {children}
    </Typography>
  ),
  heading3: ({ children }) => <>{children}</>,
  heading4: ({ children }) => <Typography variant={'headlineXSmall'}>{children}</Typography>
}
